<template>
  <div>
    <title-bar :title-stack="titleStack" />
    <hero-bar>
      Customer Account Manager Support Overview
      <b-button slot="right" type="is-primary" @click="$router.go(-1)">
        <span>Back</span>
      </b-button>
    </hero-bar>
    <section class="section is-main-section">
      <CAM-support-overview />
    </section>
  </div>
</template>

<script>
import CAMSupportOverview from "@/components/Reportingtracker/CAMSupportOverview";
import TitleBar from "@/components/TitleBar";
import HeroBar from "@/components/HeroBar";

export default {
  name: "CAMSupportOverviewMain",
  components: { HeroBar, TitleBar, CAMSupportOverview },
  computed: {
    titleStack() {
      return [
        { url: "/reportingtracker", name: "Reporting Tracker" },
        {
          url: "/reportingTracker/CAM-support-overview",
          name: "Customer Account Manager Support Overview."
        }
      ];
    }
  },
  data() {
    return {
      isModalActive: false
    };
  }
};
</script>
